import { Radio } from "lucide-react";
import { Reveal } from "./Reveal";
import { CassetteTape, Squiggle } from "./doodles";
import { STATION } from "@/config/station";

export default function ListenLive() {
    return (
        <section
            id="listen-live"
            data-testid="listen-live-section"
            className="border-b-[2.5px] border-ink bg-creamalt py-16 sm:py-24"
        >
            <div className="mx-auto max-w-6xl px-4 sm:px-6">
                <Reveal className="text-center">
                    <span className="sticker bg-sky text-white [text-shadow:none]">01 · The Player</span>
                    <h2 className="mt-4 font-condensed text-3xl font-black uppercase tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Press Play. You're Home.
                    </h2>
                    <Squiggle className="mx-auto mt-3 h-3 w-36" stroke="#3FA9F5" />
                    <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-ink2 sm:text-lg">
                        Good music, good energy. Tune in and stay awhile.
                    </p>
                </Reveal>

                <Reveal delay={0.15} className="mx-auto mt-10 max-w-3xl">
                    <div className="rounded-3xl border-[3px] border-ink bg-cream p-6 shadow-[8px_8px_0_#1A1918] sm:p-10">
                        <div className="flex flex-wrap items-center justify-between gap-3">
                            <span className="sticker bg-sunny">
                                <Radio className="h-3.5 w-3.5" strokeWidth={2.75} />
                                Official Live365 Player
                            </span>
                            <span
                                data-testid="stream-status-badge"
                                className="sticker bg-white !normal-case !tracking-normal"
                            >
                                Status: not connected yet
                            </span>
                        </div>

                        {STATION.live365EmbedUrl ? (
                            <iframe
                                data-testid="live365-player-embed"
                                src={STATION.live365EmbedUrl}
                                title="Inspiration Station — Live365 player"
                                className="mt-6 h-48 w-full rounded-2xl border-[2.5px] border-ink bg-white"
                                allow="autoplay"
                            />
                        ) : (
                            <div
                                data-testid="live365-player-placeholder"
                                className="mt-6 rounded-2xl border-[2.5px] border-dashed border-ink/50 bg-white/70 p-6 text-center sm:p-8"
                            >
                                <div className="mx-auto max-w-xs opacity-90">
                                    <CassetteTape spinning={false} />
                                </div>
                                <p className="mt-4 font-mono2 text-sm font-bold uppercase tracking-[0.18em] text-ink">
                                    Live365 player placeholder
                                </p>
                                <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-ink2">
                                    The official station player will live right here. Nothing on this
                                    page is live audio yet — no stream is connected.
                                </p>
                                <p className="mx-auto mt-3 max-w-md font-mono2 text-xs leading-relaxed text-ink2">
                                    Owner: paste your Live365 embed URL into
                                    "live365EmbedUrl" in src/config/station.js and the real player
                                    appears here automatically.
                                </p>
                            </div>
                        )}

                        <p className="mt-5 text-center font-hand text-2xl font-bold text-ink2">
                            pull up a chair — the dial is almost ready
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
